import Chart from 'chart.js/auto';

class DonutChart extends HTMLCanvasElement {

    constructor() {
        super();
        this.chart = null;
        this.actualColor = '#facf2d';
        this.nextColor = '#a4e7a1';
    }

    connectedCallback() {
        this.renderChart();
    }

    disconnectedCallback() {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    renderChart() {
        const ctx = this.getContext('2d');
        const data = this.getAttribute('data-values').split(',');
        const labels = this.getAttribute('data-labels').split(',');
        const currentValue = this.getAttribute('data-current-tonnage-percent');
        const currentTonnagePercent = this.getAttribute('data-current-tonnage');
        const chartRotation = -Math.PI;

        /**
         * On ajoute la ligne du tonnage
         * @type {{id: string, afterDraw(*): void}}
         */
        const lineLengthFactor = 2.2;
        const speedCursorPlugin = {
            id: 'speedCursor',
            afterDraw(chart) {
                const { ctx, chartArea: { width, height } } = chart;

                const centerX = width / 2 + 40;
                const centerY = height + 25;
                const radius = Math.min(width, height) / 2 * 0.9;

                const total = data.reduce((acc, val) => acc + Number(val), 0);
                const ratio = currentValue / total;
                const angle = ratio > 1 ? (total / total / 2) * 2 * Math.PI + chartRotation : (currentValue / total/2) * 2 * Math.PI + chartRotation;

                const endX = centerX + radius * lineLengthFactor *Math.cos(angle);
                const endY = centerY + radius * lineLengthFactor * Math.sin(angle);

                // Dessiner le cercle noir à la base de la ligne
                ctx.save();
                ctx.beginPath();
                ctx.arc(centerX, centerY, 5, 0, 2 * Math.PI);
                ctx.fillStyle = 'black';
                ctx.fill();
                ctx.restore();

                // Dessiner la ligne
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(centerX, centerY);
                ctx.lineTo(endX, endY);
                ctx.strokeStyle = 'black';
                ctx.lineWidth = 2;
                ctx.stroke();
                ctx.restore();

                // Afficher la valeur
                const text = currentValue + '%';
                const textOffset = 20;

                const textX = endX + (textOffset * Math.cos(angle));
                const textY = endY + (textOffset * Math.sin(angle));

                ctx.save();
                ctx.fillStyle = 'black';
                ctx.font = 'bold 12px Arial';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(text, textX, textY);
                ctx.restore();
            }
        };

        // Créer un dégradé
        const gradient = ctx.createLinearGradient(0, 0, 400, 0);
        gradient.addColorStop(0, this.actualColor);
        gradient.addColorStop(1, this.nextColor);

        this.chart = new Chart(ctx, {
            plugins: [speedCursorPlugin],
            type: 'doughnut',
            data: {
                labels: labels,
                datasets: [{
                    data: data,
                    backgroundColor: gradient, // Utiliser le dégradé au lieu d'un tableau de couleurs
                    borderWidth: 1
                }]
            },
            options: {
                cutout: '55%',
                rotation: -90,
                circumference: 180,
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 30,
                        left: 40,
                        right: 40
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                }
            }
        });
    }
}

export default DonutChart;
